'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _basicTextPage = require('./basic-text-page');

var _basicTextPage2 = _interopRequireDefault(_basicTextPage);

var _reactIntl = require('react-intl');

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locale = 'en';

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;
try {
	messages = require('../lang/' + localeBase + '.json');
} catch (error) {
	messages = require('../../src/lang/en.json');
}

(0, _reactIntl.addLocaleData)(lang);

var CookiePolicy = function CookiePolicy() {
	return _react2.default.createElement(
		_reactIntl.IntlProvider,
		{ locale: localeBase, messages: messages },
		_react2.default.createElement(
			_basicTextPage2.default,
			{
				pageTitle: 'Cookie Policy | Doctify',
				pageDescription: 'Cookie Policy at Doctify. Rate, review and book doctors and specialists online',
				pagePath: (0, _doctifyUtils.getResourcePath)('/cookie-policy')
			},
			_react2.default.createElement(
				'div',
				{ className: _style2.default.bulletsSidebar },
				_react2.default.createElement(
					'ul',
					null,
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ href: '/cookie-policy#cookie-policy' },
							_react2.default.createElement(
								'h3',
								null,
								'Cookie Policy'
							)
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ href: '/cookie-policy#what-is-a-cookie' },
							'What is a cookie?'
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ href: '/cookie-policy#how-do-we-use-cookies' },
							'How do we use cookies?'
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ href: '/cookie-policy#managing-cookies' },
							'Managing cookies'
						)
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: _style2.default.bulletsPage },
				_react2.default.createElement(
					'ol',
					null,
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'h2',
							null,
							_react2.default.createElement(
								'span',
								{ className: _style2.default.num },
								'1. '
							),
							_react2.default.createElement('a', { id: 'cookie-policy' }),
							'Cookie Policy'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.content },
						'Our website uses cookies to distinguish you from other users of the Doctify website ("the Site"). This helps us to provide you with a good experience when you browse our site and also allows us to improve our site. By continuing to browse our site, you are agreeing to our use of cookies.'
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'h2',
							null,
							_react2.default.createElement(
								'span',
								{ className: _style2.default.num },
								'2. '
							),
							_react2.default.createElement('a', { id: 'what-is-a-cookie' }),
							'What is a cookie?'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.content },
						'A cookie is a small file of letters and numbers that we store on your browser or the hard drive of your computer if you agree. Cookies contain information that is transferred to your computer\u2019s hard drive.'
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'h2',
							null,
							_react2.default.createElement(
								'span',
								{ className: _style2.default.num },
								'3. '
							),
							_react2.default.createElement('a', { id: 'how-do-we-use-cookies' }),
							'How do we use cookies?'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.content },
						'We will use the information collected to make our website more relevant to your interests.'
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.content },
						'We may also share this information with third parties for this purpose.'
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.content },
						'We use the following types of cookie:',
						_react2.default.createElement(
							'ul',
							null,
							_react2.default.createElement(
								'li',
								null,
								'Essential cookies. These are cookies that are required for the operation of our website'
							),
							_react2.default.createElement(
								'li',
								null,
								'Analytical/performance cookies. They allow us to recognise and count the number of visitors and to see how visitors move around our website when they are using it.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Functionality cookies. These are used to recognise you when you return to our website.'
							),
							_react2.default.createElement(
								'li',
								null,
								'Targeting cookies. These cookies record your visit to our website, the pages you have visited and the links you have followed.'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.content },
						'Please note that third parties (including, for example, advertising networks and providers of external services like web traffic analysis services) may also use cookies, over which we have no control. These cookies are likely to be analytical/performance cookies or targeting cookies.'
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'h2',
							null,
							_react2.default.createElement(
								'span',
								{ className: _style2.default.num },
								'4. '
							),
							_react2.default.createElement('a', { id: 'managing-cookies' }),
							'Managing Cookies'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.content },
						'You can block cookies by activating the setting on your browser that allows you to refuse the setting of all or some cookies. However, if you use your browser settings to block all cookies (including essential cookies) you may not be able to access all or parts of our site.'
					)
				)
			)
		)
	);
};

CookiePolicy.displayName = 'CookiePolicy';

CookiePolicy.defaultProps = {};

exports.default = CookiePolicy;


// WEBPACK FOOTER //
// ./components/info-page/lib/components/cookie-policy-page.js